import React, { useEffect, useState } from "react";


import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Picker from "react-mobile-picker";
import { useTranslation, Trans } from "react-i18next";
import Popup from "../Popup/BasePopup";
import Button from "../CommonFields/Button";

const CategoryDropDown = ({ cancel, getTitle, showDropDownValues, values , isOpen, onClose, title }) => {
  //  console.log("called",values)
  const { t } = useTranslation();
  const [selectedItem, setSelectedItem] = useState("");
  const generateVallue = (val) => {
    var valu = [];
    if (values?.length > 0) {
      for (let i = 0; i < values.length; i++) {
        valu.push(values[i]);
      }
      return valu;
    } else {
      return [];
    }
  };
  //  const value = values?.map((ele) => ele.value)
  // console.log(value)
  const [isCancel, setIsCancel] = useState(cancel);

  // console.log(optionGroups)
  const maskStyle = {
    display: isCancel ? "block" : "none",
  };


  const [valueGroups, setValueGroups] = useState({
    titles: "a",
  });
  const [optionGroups, setOptionGroups] = useState({
    titles: generateVallue(),
  });
  useEffect(() => {
    if (values.length > 0) var arr = generateVallue();
    setOptionGroups({ titles: arr });
    setValueGroups({ titles: arr[0] });
  }, []);

  const isCancelHandler = () => {
    setIsCancel(false);
    showDropDownValues();
  };
  const doneHandler = () => {
    // console.log("clicked")
    // console.log(valueGroups)
    setIsCancel(false);
    getTitle(valueGroups.titles);
    // isCancelHandler()
  };
  const handleChange = (name, value) => {
    // console.log(name, value)
    setValueGroups((preVaue) => ({ ...preVaue, [name]: value }));
    setSelectedItem(valueGroups.titles);
    // console.log("called", selectedItem)
  };
  // console.log("156")
  return (
    // <h2>Hello</h2>
    <>
      {/* <div className="dobns_main_div" style={maskStyle}>
        <ToastContainer />
        <div className="dobns_popup">
          <div className="dobns_header">
            
            
          </div>

          <div className="dobns_body">
            <div className="all_sub_screens_div_related_to_ads">
              <div className="dobns_body_scrollable_component">
            
                
                <div className="picker-modal-container" style={maskStyle}>
                     
                      <div className='picker-modal picker-modal-toggle popMobile'>
                        <div className="ios-datepicker">
                          <div className="ios-datepicker-title">Select Category</div>
                          
                          <div className="dobns_cancel_icon">
                                <img
                                    src={Cancel}
                                    onClick={
                                    isCancelHandler
                                    }
                                />
                            </div>
                            
                        </div>
                        
                        <Picker
                          optionGroups={optionGroups}
                          valueGroups={valueGroups}
                          onChange={handleChange} 
                          wheel='natural'

                          />
                         <div className="doneBtn"> <button onClick={doneHandler}>Done</button></div>
                      </div>
                      
                    </div> 
                </div>
           </div>

                
          </div>
        </div>
      </div> */}

<Popup isOpen={true} onClose={isCancelHandler} title={title}>
            {/* <Picker
              optionGroups={optionGroups}
              valueGroups={valueGroups}
              onChange={handleChange}
              wheel="natural"
            /> */}
            <Picker
              value={valueGroups}
              onChange={setValueGroups}
              wheel="natural"
              className="picker-date "
            >
              {Object.keys(optionGroups).map((name) => (
                <Picker.Column key={name} name={name} className="option">
                  {optionGroups[name].map((option) => (
                    <Picker.Item key={option} value={option}>
                      {option}
                    </Picker.Item>
                  ))}
                </Picker.Column>
              ))}
            </Picker>
            <div className="doneBtn">
             <Button text="done" onClick={doneHandler} />
            </div>
            </Popup>
    </>
  );
};

export default CategoryDropDown;

